import { Outlet } from "react-router";
import { Toaster } from "@/components/ui/sonner";

const RootLayout: React.FC = () => {
  return (
    <div className="root-layout bg-indigo-50 h-[100dvh] text-base leading-relaxed text-slate-600">
      <Outlet />
      <Toaster richColors closeButton position="bottom-left" />
    </div>
  );
};

export default RootLayout;
